import {AIChapter} from "./aiChapter.model";
import {SlideGenerationMode} from "@/util/generationModeEnum";

export class AISpeach {
    title: string;
    description: string;
    chapters: AIChapter[];
    // BCP-47 code of the language the plan was generated in, reported by speach-llm. Kept here so it
    // survives the plan → validateSteps round-trip; the backend uses it to resolve "auto-detect" to a
    // concrete generationOptions.lang (see AISpeachGenerator.validateSteps).
    public language:string="";
    public generationOptions:AISpeachOption=new AISpeachOption();
    constructor() {
        this.title = "";
        this.description = "";
        this.chapters = [];
    }
}


export class AISpeachOption{
  public lang:string=""
  public customInstruction:string=""
  public generationMode:SlideGenerationMode=SlideGenerationMode.ENHANCED
  // Style choices picked at the Style step. Persisted with the AISpeach so
  // the "Continue via AI" flow can restore them without asking the user again.
  public avatar:string|null=null
  public background:string|null=null
  public voice:string|null=null
  public imageStyle:string|null=null
  // Key of the visual template picked at the Style step (see
  // LIST_OF_VISUAL_TEMPLATES). Persisted so "Continue via AI" restores it.
  // The template's hiddenPrompt is merged into customInstruction at POST time.
  public visualTemplate:string|null=null
  // Whether the LLM generates automatic video annotations (Style step toggle).
  // Persisted so "Continue via AI" restores it. Default true.
  public annotationsEnabled:boolean=true
  // Whether the user enabled the avatar at the Style step. This — not avatar null-ness —
  // is the on/off signal for the avatar slide layouts downstream (a coherent, gender-matched
  // avatar is always sent regardless). Persisted so "Continue via AI" restores it.
  public useAvatar:boolean=true
}
